// extracted by mini-css-extract-plugin
module.exports = {"popupContent":"styles_popupContent__3bUWz","popupTitle":"styles_popupTitle__394Cg","popupButton":"styles_popupButton__OYU-Z"};